import 'slick-carousel';
export default {
  init() {
    if ($(window).width() < 768) {
      $('.reviews-slider-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.slick-reviews-prev'),
        nextArrow: $('.slick-reviews-next'),
        dots: true,
        adaptiveHeight: true,
      });
    } else {
      $('.reviews-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.slick-reviews-prev'),
        nextArrow: $('.slick-reviews-next'),
        dots: true,
        adaptiveHeight: true,
      });
    }

    // JavaScript to be fired on all pages
    $('.toggle-box:first-child').addClass('toggle-open');
    $('.toggle-box:first-child .toggle-description').css('display', 'flex');
    $('.toggle-title').on('click', function () {
      $('.toggle-box').removeClass('toggle-open');
      $('.template-capital-campaign .toggle-description').slideUp();
      $(this).parent().toggleClass('toggle-open');
      $(this).parent().find('.toggle-description').slideToggle();
      $(this).parent().find('.toggle-description').css('display', 'flex');
    });

    $(window).scroll(function() {
      if ($(window).scrollTop() >= 600) {
        $('.menu-sticky-wrap').addClass('sticky');
      } else {
        $('.menu-sticky-wrap').removeClass('sticky');
      }
    });

    $('.video-item').on('click', function () {
      let v = $(this).html();
      $('#gallery-modal .modal-body').html(v);
      $('#gallery-modal .modal-body iframe').addClass('frame-video');
      let videoSrc = $('.frame-video').attr('src');
      videoSrc = videoSrc+ '&autoplay=1';
      $('.frame-video').attr('src', videoSrc);
    });

    $('#gallery-modal').on('hidden.bs.modal', function () { // on closing the modal
                                                       // stop the video
      $('#gallery-modal iframe').attr('src', null);
    });

    $('.menu-toggle').on('click', function () {
      $('.menu-toggle').toggleClass('active');
      $('.top-menu-wrap').slideToggle();
    });

    $('.nav > .menu-item').on('click', function () {
      $(this).toggleClass('active');
      $(this).find('.sub-menu').slideToggle();
    });

    $('.toggle-svg').on('click', function () {
      $('.toggle-phone').slideToggle();
    });


    $('.wpcf7-radio input').change(function() {
      $('.wpcf7-radio label').removeClass('checked');
      $(this).parent().addClass('checked');
    });

    $('.wpcf7-checkbox input').change(function() {
      $(this).parent().toggleClass('checked');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js